import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct, NgbDate, NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-news-year-create',
  templateUrl: './news-year-create.component.html',
  styleUrls: ['./news-year-create.component.scss']
})
export class NewsYearCreateComponent implements OnInit {

  constructor(private calendar: NgbCalendar, private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  dateFull = null;
  submitted = false;
  public Form: FormGroup;

  public model: NgbDateStruct;
  public date: { year: number, month: number };
  public modelFooter: NgbDateStruct;

  selectToday() {
    this.model = this.calendar.getToday();
  }

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/newsYearbyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              _id: data.data._id,
              year: data.data.customYear,
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });


    this.Form = this.formBuilder.group({
      year: ['', [Validators.required]],
      _id: ['']
    })
  }

  get f() { return this.Form.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }
    let monthString = ['', "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    let year = this.Form.value.year;
    let yearsplit = year.split("-");
    
     if(this.action == 'Submit'){
       
    var data = {
      "year" : monthString[yearsplit[1].replace(/\b[0]/g, '')] + ' ' + yearsplit[0],
      "customYear" : this.Form.value.year,
      "admin" : sessionStorage.getItem('adminName'),
    };
    // console.log(data);
    this.http.post<any>(this.api_endpoint+'/newsYear', data).subscribe(
      res => {
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/news-year/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }else{
    var data1 = {
      "year" : monthString[yearsplit[1].replace(/\b[0]/g, '')] + ' ' + yearsplit[0],
      "customYear" : this.Form.value.year,
      "admin" : sessionStorage.getItem('adminName'),
      "_id" : this.Form.value._id,
    };
      // console.log(data1);     
      this.http.put<any>(this.api_endpoint+'/newsYear/', data1).subscribe(
      res => {
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/news-year/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  } 
  }

}
